<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Meldebox</h1>

    <p class="mb-3">
      Vielen Dank für Ihren Hinweis. Wir bestätigen den Eingang Ihrer Meldung und sichern Ihnen höchste Vertraulichkeit zu. Sollte Ihr Hinweis nicht anonym erfolgt sein, werden wir Sie über den Stand der Bearbeitung auf dem Laufenden halten. Wir prüfen schnellstmöglich, ob der von Ihnen gemeldete Verstoß stichhaltig ist und in den Anwendungsbereich der Vertrauens- und Meldestelle fällt.
    </p>
    <p class="mb-3">
      Wie geht es weiter?<br>
      Wir halten Kontakt mit Ihnen und - sofern erforderlich, bitten wir Sie um weitere Informationen, um angemessene Folgemaßnahmen zu ergreifen. Sie erhalten innerhalb von drei Monaten nach der Eingangsbestätigung eine Rückmeldung über die geplanten oder bereits ergriffenen Folgemaßnahmen und deren Gründe, sofern dadurch nicht die laufenden Ermittlungen bzw. Rechte betroffener Personen beeinträchtigt werden. Als Folgemaßnahmen unserer interne Vertrauensstelle können wir
    </p>

    <ul class="ml-4 mb-3 list-disc">
      <li class="mb-2">interne Untersuchungen beim Arbeitgeber oder bei der jeweiligen Organisationseinheit durchführen und betroffene Personen und Arbeitseinheiten kontaktieren.</li>
      <li class="mb-2">das Verfahren zwecks weiterer Untersuchungen an eine bei uns zuständige Arbeitseinheit für interne Ermittlungen oder eine zuständige Behörde abgeben.</li>
      <li class="mb-2">Sie ggf. an andere zuständige Stellen verweisen.</li>
      <li class="mb-2">das Verfahren aus Mangel an Beweisen oder aus anderen Gründen einstellen.</li>
    </ul>

    <div class="my-6 p-8 bg-gray-300">
      <p class="mb-3">Sie bekommen jetzt ein Passwort, damit Sie Sich wieder einloggen können und sehen, wie der Stand der Bearbeitung des Falles ist. </p>
      <p class="mb-3">
        Ihr Passwort:
      </p>
      <p class="mb-3 text-5xl">
        {{ kennwort }}
      </p>
      <p class="mb-3">
        Vielleicht haben wir noch Fragen an Sie oder es gibt Aktualisierungen, die Sie interessieren. Wir haben keine andere Chance als diese, mit Ihnen zu kommunizieren, daher speichern Sie bitte das Passwort gut ab, es ist danach gelöscht und kann nicht wieder aufgerufen werden. Wir, Ihr Arbeitgeber, werden versuchen, schnell zu antworten.
      </p>
    </div>

    <p class="mb-3">
      Mit freundlichen Grüßen<br>
      Ihre interne Meldestelle
    </p>

  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout2'

export default {
  components: {
    Head,
  },
  layout: Layout,
  props: {
    kennwort: String,
  },
}
</script>
